import { useEffect, useState } from "react";
import axios from "axios";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { id: "f1", question: "What is KIS Living Vacations?", answer: "KIS Living Vacations is a curated travel platform sharing resort stays, cruises, group travel ideas, and travel inspiration." },
  { id: "f2", question: "Can I book directly through the website?", answer: "You can submit your travel interest through the website. We will review availability and share next steps." },
  { id: "f3", question: "Do you support group travel?", answer: "Yes. KIS Living Vacations supports group travel interests including family trips, birthdays, retreats, festivals, reunions, and cruise groups." },
  { id: "f4", question: "Are deposits required?", answer: "Some travel offers may require a deposit. Deposit and cancellation details will be shared clearly before confirmation." },
  { id: "f5", question: "How far in advance should I request travel?", answer: "The earlier the better, especially for peak travel seasons, group trips, and resort stays." },
];

export const FAQ = () => {
  const [faqs, setFaqs] = useState(FALLBACK);

  useEffect(() => {
    axios.get(`${API}/faqs`).then(({ data }) => { if (data.length > 0) setFaqs(data); }).catch(() => {});
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-32 bg-sand">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <p className="uppercase text-sm tracking-[0.2em] font-semibold text-terracotta mb-4">
            Good to know
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ink">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.id || i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-bone"
            >
              <AccordionTrigger className="text-left font-serif text-xl sm:text-2xl font-medium text-ink hover:no-underline py-6">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-ink-soft pb-6">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
